import React, {Fragment} from "react";
import logoGladly from 'components/images/logos/logo_gladly.svg'
import useGladlySetup from "./useGladlySetup";
import GladlySetupModal from "./GladlySetupModal";
import ChannelCard from "../../Utilities/ChannelCard";

export default function GladlyProvider() {
	const { initiateGladlySetup, gladlySetupOpen, handleGladlySetupOpen, handleGladlySetupClose } = useGladlySetup()

	return (
		<Fragment>
			<ChannelCard
				icon={logoGladly}
				label={'Gladly'}
				description={'Send personalized winback messages or resolve support tickets'}
				onClick={initiateGladlySetup}
			/>

			<GladlySetupModal
				open={gladlySetupOpen}
				handleOpen={handleGladlySetupOpen}
				handleClose={handleGladlySetupClose}
			/>
		</Fragment>
	)
}